import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const POST_AUTH_KEY = 'homphy_post_auth_redirect';

/** After a guest signs in or up, send them back to the page they were trying to reach. */
export default function PostAuthRedirect() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    let next: string | null = null;
    try { next = sessionStorage.getItem(POST_AUTH_KEY); } catch { /* storage unavailable */ }
    if (!next || !next.startsWith('/')) return;
    // Small delay so it runs after the auth page's own redirect
    const timer = setTimeout(() => {
      try { sessionStorage.removeItem(POST_AUTH_KEY); } catch { /* ignore */ }
      navigate(next as string, { replace: true });
    }, 400);
    return () => clearTimeout(timer);
  }, [user, navigate]);

  return null;
}